module.exports = __webpack_public_path__ + "static/img/108003.2ae7ad01.png";